import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _capitalize from 'lodash/capitalize';

import { useTrackingData } from './DataProviders';
import { carrierEventType } from '../propTypes';


export default function TrackingEvents({ eventClassName, timestampFormat, eachEvent, emptyMsgClassName }) {
  const { carrier_events = [] } = useTrackingData();

  if( !carrier_events.length ) {
    return <div className={emptyMsgClassName}>
      Your label has been created. Tracking status will appear once the carrier has received the shipment.
    </div>;
  }

  if( eachEvent ) {
    return (
      carrier_events.map( (event,index) => eachEvent({
        content: <TrackingEvent
                   event={event}
                   key={event.occurred_at}
                   className={eventClassName}
                   timestampFormat={timestampFormat}
                   index={index}
                 />,
        key: event.occurred_at,
        event: event,
        index: index
      }))
    );
  }

  return (
    carrier_events.map( event => (
      <TrackingEvent
        event={event}
        key={event.occurred_at}
        className={eventClassName}
        timestampFormat={timestampFormat}
      />
    ))
  );
}


// See https://momentjs.com/docs/#/displaying/format/ for `timestampFormat`
export function TrackingEvent({ event, className='', timestampFormat='', index }) {
  const {
    occurred_at: occurredAt,
    city_locality: cityLocality,
    country_code: countryCode,
    state_province: state,
    description,
  } = event;

  const timestamp = occurredAt && moment(occurredAt).isValid() && moment(occurredAt);

  const formattedTimestamp = timestamp && timestamp.format(timestampFormat);

  const city = _capitalize((cityLocality || '').toLocaleLowerCase());
  const country = countryCode !== 'US' ? countryCode : '';
  const location = [city, state, country].filter((e) => e).join(', ');

  return (
    <div className={className} role="listitem" data-testid={index === 0 && 'latest-tracking-event'}>
      <span className="timestamp" title={timestamp && timestamp.toISOString()}>{formattedTimestamp}</span>
      <span className="description">{description}</span>
      <span className="location">{location}</span>
    </div>
  );
}

TrackingEvent.propTypes = {
  event: carrierEventType.isRequired,
  className: PropTypes.string,
  timestampFormat: PropTypes.string
};
